import React from "react";
import { createRoot } from 'react-dom/client';
import SiteSearch from "../components/SiteSearch";

const renderSiteSearch = ($) => {

	const searchElement = $("#js-site-search")[0];
	
	let props = {
		...(searchElement && searchElement.dataset),
	};

	if (searchElement) {
		const root = createRoot(searchElement);
		root.render(<SiteSearch {...props} />);
	}
};

export default renderSiteSearch;